import React from 'react';
import { Helmet } from 'react-helmet';

import PropTypes from 'prop-types';

const DEFAULT_OG_IMAGE = 'https://api.supremegolf.com/og_image.jpg';

class MetaTagsHelper {
  static buildHelmetTags({
    title, description, imageSrc, keywords, titleTemplate,
  }) {
    return (
      <Helmet titleTemplate={titleTemplate || `%s | ${process.env.REACT_APP_META_TITLE}`}>
        <title>{title}</title>
        <meta name="keywords" content={keywords} />
        <meta name="description" content={description || process.env.REACT_APP_DEFAULT_DESCRIPTION} />

        {/* default meta tags */}
        <meta property="og:title" content={title} />
        <meta property="og:image" content={imageSrc || DEFAULT_OG_IMAGE} />
        <meta
          property="og:description"
          content={description || process.env.REACT_APP_DEFAULT_DESCRIPTION}
        />
        {/* Twitter meta tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:image" content={imageSrc || DEFAULT_OG_IMAGE} />
        <meta property="twitter:site" content={process.env.REACT_APP_TWITTER_ACCOUNT} />
        <meta
          property="twitter:description"
          content={description || process.env.REACT_APP_DEFAULT_DESCRIPTION}
        />
      </Helmet>
    );
  }
}

MetaTagsHelper.defaultProps = {
  titleTemplate: `%s | ${process.env.REACT_APP_META_TITLE}`,
};

MetaTagsHelper.propTypes = {
  titleTemplate: PropTypes.string,
};

export default MetaTagsHelper;
